import { AddForestCrew } from '@features/Contractor/ForestCrew/Add'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const AddForestCrewRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  return <AddForestCrew contractorId={contractorId} />
}

export const Route = createFileRoute('/contractor/$contractorId/forest-crews/add')({
  component: AddForestCrewRoute,
  staticData: {
    breadcrumb: t('contractor.addForestCrew.title'),
  },
})
